



! function(n) {
    window.fp_scrollHorizontallyExtension = function() {
        var l = this,
            o = n.fn.fullpage.getFullpageData(),
            e = o.options,
            t = o.internals,
            i = "active",
            r = "." + i,
            f = "fp-section",
            a = "." + f,
            c = a + r,
            u = "fp-slide",
            d = "." + u,
            s = d + r;
        l.getScrollSection = function(l, o) {
            var t, i = n(c),
                r = i.find(d).length,
                f = e.scrollHorizontally && r > 1;
            if (f)
                if (t = i.find(s), "down" === l) {
                    if (t.index() + 1 != r) return n.fn.fullpage.moveSlideRight
                } else if (t.index()) return n.fn.fullpage.moveSlideLeft;
            return o
        }, l.c = t.c;
        var p = l["common".charAt(0)];
        return "complete" === document.readyState && p("scrollHorizontally"), n(window).on("load", function() {
            p("scrollHorizontally")
        }), l
    }
}(jQuery);

PIXI.utils.skipHello();

    var scaleImg1 = new Image();
        scaleImg1.src='/wp-content/themes/freshmail/assets/img/kariera/it/1000.png';
    var scaleImg2 = new Image();
        scaleImg2.src='/wp-content/themes/freshmail/assets/img/kariera/it/3000.png';
    var scaleImg3 = new Image();
        scaleImg3.src='/wp-content/themes/freshmail/assets/img/kariera/it/10000.png';
    var scaleImg4 = new Image();
        scaleImg4.src='/wp-content/themes/freshmail/assets/img/kariera/it/20000.png';
    var scaleImg5 = new Image();
        scaleImg5.src='/wp-content/themes/freshmail/assets/img/kariera/it/40000000.png';
    var scaleImg6 = new Image();
        scaleImg6.src='/wp-content/themes/freshmail/assets/img/kariera/it/250000000.png';





function Grid(id, color, width, height, snakesCount, interactive, image, imageMobile, autoplay){
    this.canvas = document.getElementById(id);
    this.color = color;
    this.appWidth = window.innerWidth;
    this.appHeight = window.innerHeight;
    this.ratio = width/height;
    this.snakesCount = snakesCount;
    this.interactive = interactive;
    this.image = image;
    this.imageMobile = imageMobile;
    this.autoplay = autoplay;
    this.resizing = false;
}
Grid.prototype.stop = function() {
    this.app.stop();
}

Grid.prototype.play = function() {
    this.app.start();
}

Grid.prototype.init = function(){
    this.app = new PIXI.Application(this.appWidth, this.appHeight, {view: this.canvas});
    this.app.renderer.backgroundColor = this.color;
    this.app.stop();

    var that = this;

    if(this.image) {
        if(this.appHeight < 750 && this.imageMobile) this.image = this.imageMobile;
        var img = new Image();
        img.crossOrigin="anonymous";
        img.src=this.image;
       
        img.onload = function(){
            that.makeGrid(that.interactive, that.snakesCount, img);
        }
    } else {
        this.makeGrid(this.interactive, this.snakesCount, this.image);
    }

    if(this.autoplay) {
        this.play();
    } else {
        this.app.render();
    }

}

Grid.prototype.changeImage =  function(img) {
    this.app.stop();
    if(img) {
        this.image = img.src; 
    } else {
        this.image = false;
    }

    while(this.app.stage.children[0]) { this.app.stage.removeChild(this.app.stage.children[0]); }
    if(img) {
        var that = this;
        that.makeGrid(that.interactive, that.snakesCount, img);
    } else {
        this.makeGrid(this.interactive, this.snakesCount, this.image);
    }
    this.play();
}

Grid.prototype.makeGrid = function(interactive, snakesCount, img){
    var textures = [];
    var imgWidth,
        imgHeight,
        centerPoint;
    for(var i=0; i<120; i++) {
        textures[i] = new Array(120);
    }

    var posx = 0;
    var posy = 0;
               var canvas = document.createElement("canvas");
    canvas.width = this.appWidth;
    canvas.height = this.appHeight;
    if(img){
 
    var context = canvas.getContext("2d");
    if(img.naturalWidth > this.appWidth){
        var scale = (this.appWidth-60)/img.naturalWidth;
        context.scale(scale,scale);
        imgWidth = img.naturalWidth * scale;
        imgHeight = img.naturalHeight * scale; 
        centerPoint =  50 + 100 * scale;

    } else {
        imgWidth = img.naturalWidth;
        imgHeight = img.naturalHeight;  
        centerPoint = 50;
    }

    context.drawImage(img, Math.ceil((((this.appWidth - imgWidth)/2)-18)/18) * 18, Math.ceil(((this.appHeight + centerPoint - imgHeight)/2)/18) * 18);


    var imageData = context.getImageData(0, 0, canvas.width, canvas.height);
    data = imageData.data;
    }
    



    for (var i = 0; i < canvas.width; i += 18) {
    posy = 0;
        for (var j = 0; j < canvas.height; j += 18) {
            var color = 0;
if(img){
            color = data[((j * (imageData.width * 4)) + (i * 4)) - 1];
      }
            if (color == 255) {     var fill = '0xffffff';

  var explosion = new PIXI.extras.AnimatedSprite(explosionTextures);

        explosion.position.x = i+7;
        explosion.position.y = j+7;
        explosion.anchor.set(0.5);

   
        explosion.animationSpeed = 0.08 + Math.random() * 0.2;
        explosion.gotoAndPlay(Math.random() * 27);
        this.app.stage.addChild(explosion);




        } else {    


                if(this.interactive){
                    var texture = new PIXI.extras.AnimatedSprite(circlesTextures);
                } else {
                    var texture = new PIXI.extras.AnimatedSprite(circlesHiddenTextures);
                }
          
            
        texture.position.x = i+7;
        texture.position.y = j+7;
        texture.anchor.set(0.5);
                    texture.interactive = this.interactive;
                    if(navigator.userAgent.toLowerCase().indexOf('firefox') > -1){
                        texture.interactive = false;
                    }
                texture.hitArea = new PIXI.Rectangle(0,0,25,25);

   
    
        texture.loop = false;
   

          texture.animationSpeed = 0.5;
 
        this.app.stage.addChild(texture);
    
        
                texture.mouseover = function(data) {
                         this.gotoAndPlay(0);
                }
      
           
                textures[posx][posy] = texture;
            

             }
           
        posy += 1;

 }

      posx += 1;
    
}

  
   var makeSnake = function(row, column, vertical, time) {
       var snakeindicator = vertical ? row : column;
       var start = vertical ? Math.floor(Math.random() * posx) + 1 : Math.floor(Math.random() * posy) + 1;
       if(vertical) {
            var snake = setInterval(
                function(){ 
                    if(snakeindicator == posx)  {
                        clearInterval(snake);
                        makeSnake(0, start, true, time)
                    } else {
                        if(textures[column][snakeindicator] != undefined) {
                            textures[column][snakeindicator].gotoAndPlay(0); 
                        }
                        snakeindicator +=1;  
                    } 
                },
            time);
       } else {
        var snake = setInterval(
            function(){ 
                if(snakeindicator == posx)  {
                    clearInterval(snake);
                    makeSnake(start, 0, false, time)
                } else {
                    if(textures[snakeindicator][row] != undefined) {
                        textures[snakeindicator][row].gotoAndPlay(0); 
                    }
                    snakeindicator +=1;  
                } 
            },
        time);
       }

   }

    var generateSnakes = function(vertical, horizontal, time){
        for(var i = 0; i<vertical; i++){
            makeSnake(Math.floor(Math.random() * posy) + 1, Math.floor(Math.random() * posx) + 1, true, time);
        }
        for(var i = 0; i<horizontal; i++){
            makeSnake(Math.floor(Math.random() * posx) + 1, Math.floor(Math.random() * posy) + 1, false, time);
        }
    }

    
    generateSnakes(snakesCount, snakesCount, 70);

    
}

if(window.innerWidth > 1024) {
    var is_safari = navigator.userAgent.indexOf("Safari") > -1;
    PIXI.loader
        .add('circleAnimation', '/wp-content/themes/freshmail/assets/img/kariera/it/circle.json')
        .add('circleFade', '/wp-content/themes/freshmail/assets/img/kariera/it/circlestatic.json')
        .add('circleHiddenFade', '/wp-content/themes/freshmail/assets/img/kariera/it/circlestatichidden.json')
        .load(startApp);
}
    
    var introGrid = new Grid('it-intro', '0x3a5399', 1920, 1000, 3, true, '/wp-content/themes/freshmail/assets/img/kariera/it/logo.png','/wp-content/themes/freshmail/assets/img/kariera/it/logo_mobile.png', true);
    var peopleGrid = new Grid('it-people', '0x703a99', 1920, 1000, 1, false, false,false, false);
    
    var scaleGrid = new Grid('it-scale', '0xacd037', 1920, 1000, 1, false, false,false, false);

    var challangeGrid = new Grid('it-challange', '0xff9c33', 1920, 1000, 1, false, '/wp-content/themes/freshmail/assets/img/kariera/it/squares.png',false, false);
    var challangeSlide1 = new Grid('it-challange-1', '0xff9c33', 1920, 1000, 1, false, '/wp-content/themes/freshmail/assets/img/kariera/it/snake.png',false, false);
    var challangeSlide2 = new Grid('it-challange-2', '0xff9c33', 1920, 1000, 1, false, '/wp-content/themes/freshmail/assets/img/kariera/it/waves.png',false, false);

    var technologyGrid = new Grid('it-technology', '0x47aade', 1920, 1000, 1, false, false,false, false);

    var explosionTextures = [],
        circlesTextures = []
        circlesHiddenTextures = [];


function startApp() {

    for (var i = 0; i < 7; i++) {
         var texture = PIXI.Texture.fromFrame('circle' + (i+1) + '.png');
         explosionTextures.push(texture);
    }

    for (var i = 0; i < 18; i++) {
         var circleTexture = PIXI.Texture.fromFrame('circlestatic' + (i+1) + '.png');
         circlesTextures.push(circleTexture);
    }

    for (var i = 0; i < 10; i++) {
        var circleHiddenTexture = PIXI.Texture.fromFrame('circlestatichidden' + (i+1) + '.png');
        circlesHiddenTextures.push(circleHiddenTexture);
   }

    introGrid.init();
    peopleGrid.init();
    scaleGrid.init();
    challangeGrid.init();
    technologyGrid.init();

    challangeSlide1.init();
    challangeSlide2.init();

}



jQuery(document).ready(function() {
    var resizing = false;
    var widthToCheck = window.innerWidth;
    window.addEventListener('resize', function(){

            if(!resizing && widthToCheck != window.innerWidth){
                resizing = true;
                location.reload();
            }

    }, false);

    if(window.innerWidth > 1024) {
     var slideIndex = 1, sliding = false;
     var currentSlide = 0;
    jQuery('#fullpage').fullpage({
        slideSelector: '.fullslide',
        anchors: ['intro', 'ludzie', 'skala', 'wyzwania', 'agile', 'technologie', 'praca'],
        scrollHorizontally: true,
        lockAnchors: false,
        loopHorizontal: false,
        scrollOverflow: true,
        afterSlideLoad: function(anchorLink, index, slideAnchor, slideIndex) {
            sliding = false;
        },
        onLeave: function(index, nextIndex, direction){
            if(nextIndex > 1) {
                jQuery('.scrollToTop').addClass('active');
            } else {
                jQuery('.scrollToTop').removeClass('active');
            }
            if(nextIndex > 1) {
                jQuery('.it-pagination').removeClass('page-color-'+index).addClass('page-color-'+nextIndex).fadeIn();
                jQuery('.it-pagination li').removeClass('active');
                jQuery(jQuery('.it-pagination li').get(nextIndex-2)).addClass('active');

            } else {
                jQuery('.it-pagination').fadeOut();
            }


            var gridToStart = jQuery(jQuery('.section').get(nextIndex-1)).data('grid');
            var gridToStop = jQuery(jQuery('.section').get(index-1)).data('grid');
            if(gridToStart != undefined) {
                window[gridToStart].play();
            }
            if(gridToStop != undefined) {
                window[gridToStop].stop();
            }
        },
        onSlideLeave: function(anchorLink, index, slideIndex, direction, nextSlideIndex){
        
            var slidedata = [index, slideIndex, nextSlideIndex];


         if(index==3) {
                if(nextSlideIndex == 0) {
                    scaleGrid.changeImage();
                }
                if(nextSlideIndex == 1) {
                    scaleGrid.changeImage(scaleImg1);
           
                }
                if(nextSlideIndex == 2) {
                    scaleGrid.changeImage(scaleImg2);
             
                }
                if(nextSlideIndex == 3) {
                    scaleGrid.changeImage(scaleImg3);
                }
                if(nextSlideIndex == 4) {
                    scaleGrid.changeImage(scaleImg4);
                }
                if(nextSlideIndex == 5) {
                    scaleGrid.changeImage(scaleImg5);
                }
                if(nextSlideIndex == 6) {
                    scaleGrid.changeImage(scaleImg6);
                }
            } else if(index==4) {
                if(nextSlideIndex == 0)  challangeGrid.play();
                if(nextSlideIndex == 1) {
                    challangeGrid.stop();
                    challangeSlide1.play();
                }
                if(nextSlideIndex == 2) {
                    challangeSlide1.stop();
                    challangeSlide2.play();
                }
            }
        }
    });
    
    } else {
        jQuery(window).scroll(function (event) {
            var scroll = jQuery(window).scrollTop();
            if( scroll > 300 ) {
                if(!jQuery('.scrollToTop').hasClass('active')){
                    jQuery('.scrollToTop').addClass('active');
                }
            } else {
                jQuery('.scrollToTop').removeClass('active');
            }
        });
    }
});
